export default __webpack_public_path__ + "static/media/KahshEcosystem.0c65aee2.png";